import { twMerge } from 'tailwind-merge';

interface StatusTagProps {
  text: string | React.ReactNode;
  className?: string;
}

export const StatusTag = ({ text, className }: StatusTagProps) => {
  return (
    <div
      className={twMerge(
        'inline-flex justify-center px-2.5 py-1 border border-transparent bg-black text-2sm font-medium text-center rounded-md dark-mode:tracking-wide',
        className
      )}
    >
      {text}
    </div>
  );
};
